import {
  Accordion,
  Button,
  HStack,
  Stack,
  useDisclosure,
} from "@chakra-ui/react";
import {
  NotificationPreferencesDto,
  useNotificationPreferences,
} from "../hooks";
import { NotificationPreferenceCategoryAccordion } from "./notification-preference-category-accordion";
import { ResetPreferencesDialog } from "./reset-preferences-dialog";

export interface NotificationPreferenceForm {
  preferences: NotificationPreferencesDto;
  onSubmit: (preferences: NotificationPreferencesDto) => void;
  formId?: string;
}

export const NotificationPreferenceForm: React.FC<
  NotificationPreferenceForm
> = (props) => {
  const { preferences, onSubmit, formId } = props;
  const {
    notificationPreferences,
    handleChange,
    handleSubmit,
    handleSelectAll,
    handleUseDefaultSettings,
  } = useNotificationPreferences(preferences, onSubmit);
  const disclosure = useDisclosure();

  return (
    <Stack>
      <Accordion
        as="form"
        id={formId}
        onSubmit={(e) => {
          e.preventDefault();
          handleSubmit();
        }}
        defaultIndex={[0]}
        allowMultiple
      >
        {notificationPreferences.map((category, idx) => (
          <NotificationPreferenceCategoryAccordion
            key={category.id + idx}
            {...category}
            handleChange={handleChange}
            handleSelectAll={handleSelectAll}
          />
        ))}
      </Accordion>
      <HStack justifyContent="flex-end" py="6" spacing="4">
        <Button
          colorScheme="red"
          variant="link"
          onClick={() => disclosure.onOpen()}
        >
          Set to Default Preferences
        </Button>
      </HStack>
      <ResetPreferencesDialog
        onReset={handleUseDefaultSettings}
        {...disclosure}
      />
    </Stack>
  );
};
